import { useEffect } from 'react';

const BASE_TITLE = 'Ketrics Cloud';

export function useDocumentTitle(subtitle?: string | null) {
  useEffect(() => {
    document.title = subtitle ? `${BASE_TITLE} - ${subtitle}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [subtitle]);
}
